/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Sync_Changes_Missing_Group_ErrorInputs */

const en_sync_changes_missing_group_error = /** @type {(inputs: Sync_Changes_Missing_Group_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linked Event Group not found in project. Linked group id: ${i?.id}`)
};

const fr_sync_changes_missing_group_error = /** @type {(inputs: Sync_Changes_Missing_Group_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Groupe d'evenements lie introuvable dans le projet. ID du groupe lie : ${i?.id}`)
};

const de_sync_changes_missing_group_error = /** @type {(inputs: Sync_Changes_Missing_Group_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verknüpfte Ereignisgruppe im Projekt nicht gefunden. Gruppen-ID: ${i?.id}`)
};

const it_sync_changes_missing_group_error = /** @type {(inputs: Sync_Changes_Missing_Group_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi collegati non trovato nel progetto. ID gruppo collegato: ${i?.id}`)
};

const ru_sync_changes_missing_group_error = /** @type {(inputs: Sync_Changes_Missing_Group_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Связанная группа событий не найдена в проекте. Идентификатор связанной группы: ${i?.id}`)
};

const es_sync_changes_missing_group_error = /** @type {(inputs: Sync_Changes_Missing_Group_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se encontró el grupo de eventos vinculados en el proyecto. ID del grupo vinculado: ${i?.id}`)
};

const zh_cn2_sync_changes_missing_group_error = /** @type {(inputs: Sync_Changes_Missing_Group_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`项目中未找到关联事件组。关联组 ID：${i?.id}`)
};

const ja_sync_changes_missing_group_error = /** @type {(inputs: Sync_Changes_Missing_Group_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクト内にリンクされたイベントグループが見つかりません。リンクされたグループID: ${i?.id}`)
};

const hi_sync_changes_missing_group_error = /** @type {(inputs: Sync_Changes_Missing_Group_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट में लिंक्ड इवेंट ग्रुप नहीं मिला। लिंक्ड ग्रुप आईडी: ${i?.id}`)
};

const pt_pt2_sync_changes_missing_group_error = /** @type {(inputs: Sync_Changes_Missing_Group_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Grupo de eventos vinculados não encontrado no projeto. ID do grupo vinculado: ${i?.id}`)
};

/**
* | output |
* | --- |
* | "Linked Event Group not found in project. Linked group id: {id}" |
*
* @param {Sync_Changes_Missing_Group_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_missing_group_error = /** @type {((inputs: Sync_Changes_Missing_Group_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Missing_Group_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sync_changes_missing_group_error(inputs)
	if (locale === "de") return de_sync_changes_missing_group_error(inputs)
	if (locale === "it") return it_sync_changes_missing_group_error(inputs)
	if (locale === "ru") return ru_sync_changes_missing_group_error(inputs)
	if (locale === "es") return es_sync_changes_missing_group_error(inputs)
	if (locale === "zh-CN") return zh_cn2_sync_changes_missing_group_error(inputs)
	if (locale === "ja") return ja_sync_changes_missing_group_error(inputs)
	if (locale === "hi") return hi_sync_changes_missing_group_error(inputs)
	if (locale === "pt-PT") return pt_pt2_sync_changes_missing_group_error(inputs)
	return en_sync_changes_missing_group_error(inputs)
});